module.exports = __webpack_public_path__ + "img/f1118a5.png";